import { Component, input } from '@angular/core';
import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'app-parse-request-state-icon',
  templateUrl: './parse-request-state-icon.html',
  imports: [NgIcon],
})
export class ParseRequestStateIcon {
  state = input.required<'EMPTY' | 'IN_PROGRESS' | 'COMPLETE'>();
}
